import React from 'react';

export const StopPropagation = ({ children = null, shouldStopNative = false, className = null }) => {
    const stopPropagation = React.useCallback(
        e => {
            e.stopPropagation();
            if (shouldStopNative) {
                e.nativeEvent.stopImmediatePropagation();
            }
        },
        [shouldStopNative]
    );

    return (
        <div className={className} onClick={stopPropagation}>
            {children}
        </div>
    );
};
